import { Component } from '@angular/core';
import { AbstractComponent } from '../abstract-component';

@Component({
    selector: 'app-menu',
    imports: [],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.css'
})
export class MenuComponent extends AbstractComponent {

}
